import React from 'react';
import PerformableConfiguration from '~/components/performable/PerformableConfiguration';
import { FormHorizontal } from '~/components/form/layout';
import Card from '~/components/layout/Card';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { DEMO_3D_OPTIONS } from '~/tenants/nep/performable/3d/Nep3dJob';
import { NepOrderContext, NepOrderType } from '~/tenants/nep/model/NepOrder';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingle } from '~/components/zod/ZodForm';

export default function Nep3dForm({ context }: TenantPerformableFormProps<NepOrderContext>) {
  const [name, matterport, setMatterport] = useZodFormFieldSingle('matterport');

  return (
    <>
      <PerformableConfiguration>
        <FormHorizontal name="option" label="Photo Package">
          <ZodFieldSelect
            name="option"
            options={Object.entries(DEMO_3D_OPTIONS).map(([id, pkg]) => ({
              value: id,
              label: `${pkg.from}-${pkg.to} sqft`,
              disabled:
                context.metadata.type === NepOrderType.RESIDENTIAL &&
                (context.metadata.sqft > pkg.to || context.metadata.sqft < pkg.from),
            }))}
          />
        </FormHorizontal>
      </PerformableConfiguration>

      <input type="hidden" name={name} value={matterport} />

      <div className="w-full grid grid-cols-2 gap-related mt-6">
        <Card
          selected={matterport !== 'true'}
          onClick={() => {
            setMatterport('false');
          }}
        >
          <div className="font-medium">Standard</div>
          <p className="text-sm font-thin">Shot using iGuide.</p>
        </Card>

        <Card
          selected={matterport === 'true'}
          onClick={() => {
            setMatterport('true');
          }}
        >
          <div className="font-medium">Matterport</div>
          <p className="text-sm font-thin">Shot using Matterport.</p>
        </Card>
      </div>
    </>
  );
}
